import React, { useState, useEffect } from 'react';

export default function ReportSectionModal({ open, onClose, onSave, selectedCount = 0, existingSection = null }) {
  const [name, setName] = useState('');
  const [annotation, setAnnotation] = useState('');
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setName(existingSection?.name || '');
      setAnnotation(existingSection?.annotation || '');
    }
  }, [open, existingSection]);

  const handleClose = () => { if (!saving) onClose(); };

  const handleSave = async () => {
    if (!name.trim()) return;
    setSaving(true);
    try {
      await onSave({ name: name.trim(), annotation: annotation.trim() });
    } finally {
      setSaving(false);
    }
  };

  if (!open) return null;

  const isEdit = !!existingSection;
  const canSave = name.trim().length > 0 && !saving;

  return (
    <div
      onClick={(e) => { if (e.target === e.currentTarget) handleClose(); }}
      style={{
        position: 'fixed', inset: 0,
        background: 'rgba(0,0,0,0.45)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 1200,
      }}
    >
      <div style={{
        background: 'var(--cc-card-bg)',
        borderRadius: 14,
        width: '90%', maxWidth: 540,
        boxShadow: '0 8px 32px rgba(0,0,0,0.2)',
        overflow: 'hidden',
      }}>
        <div style={{ height: 3, background: 'var(--branding-app-primary)' }} />
        <div style={{ padding: '24px 28px 28px' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
            <div>
              <h3 style={{ margin: 0, fontSize: 17, fontWeight: 700, color: 'var(--cc-text-primary)' }}>
                {isEdit ? 'Edit section' : 'New report section'}
              </h3>
              {!isEdit && selectedCount > 0 && (
                <p style={{ margin: '4px 0 0', fontSize: 13, color: 'var(--cc-text-muted)' }}>
                  {selectedCount} post{selectedCount !== 1 ? 's' : ''} will be added to this section
                </p>
              )}
            </div>
            <button
              onClick={handleClose}
              disabled={saving}
              style={{ background: 'none', border: 'none', fontSize: 22, cursor: 'pointer', color: 'var(--cc-text-muted)', lineHeight: 1, padding: 4 }}
            >×</button>
          </div>

          <label style={{ display: 'block', marginBottom: 16 }}>
            <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--cc-text-primary)', display: 'block', marginBottom: 6 }}>
              Section name <span style={{ color: '#ef4444' }}>*</span>
            </span>
            <input
              value={name}
              onChange={e => setName(e.target.value)}
              onKeyDown={e => { if (e.key === 'Enter') handleSave(); }}
              placeholder=""
              maxLength={120}
              disabled={saving}
              autoFocus
              style={{
                width: '100%', boxSizing: 'border-box',
                padding: '10px 12px',
                border: '1px solid #d1d5db', borderRadius: 8,
                fontSize: 14, fontFamily: 'inherit',
                background: 'var(--cc-card-bg)',
                color: 'var(--cc-text-primary)',
                outline: 'none',
              }}
            />
          </label>

          <label style={{ display: 'block', marginBottom: 24 }}>
            <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--cc-text-primary)', display: 'block', marginBottom: 4 }}>
              Annotation{' '}
              <span style={{ fontSize: 12, fontWeight: 400, color: 'var(--cc-text-muted)' }}>(optional)</span>
            </span>
            <textarea
              value={annotation}
              onChange={e => setAnnotation(e.target.value)}
              placeholder=""
              rows={5}
              disabled={saving}
              style={{
                width: '100%', boxSizing: 'border-box',
                padding: '10px 12px',
                border: '1px solid #d1d5db', borderRadius: 8,
                fontSize: 14, fontFamily: 'inherit',
                resize: 'vertical',
                background: 'var(--cc-card-bg)',
                color: 'var(--cc-text-primary)',
                outline: 'none',
                lineHeight: 1.55,
              }}
            />
          </label>

          <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
            <button
              onClick={handleClose}
              disabled={saving}
              style={{
                background: 'var(--cc-cancel-bg)', color: 'var(--cc-text-primary)',
                border: 'none', borderRadius: 8, padding: '9px 18px',
                fontWeight: 500, fontSize: 14, cursor: saving ? 'not-allowed' : 'pointer',
              }}
            >Cancel</button>
            <button
              onClick={handleSave}
              disabled={!canSave}
              style={{
                background: canSave ? 'var(--branding-app-primary)' : '#cbd5e1',
                color: canSave ? 'var(--branding-app-primary-fg)' : '#64748b',
                border: 'none', borderRadius: 8, padding: '9px 20px',
                fontWeight: 600, fontSize: 14, cursor: canSave ? 'pointer' : 'not-allowed',
              }}
            >
              {saving ? 'Saving…' : isEdit ? 'Save changes' : 'Create section'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
